import { z } from 'zod';

// `z.instanceof(Uint8Array)` infers as `Uint8Array<ArrayBuffer>` (the constructor's
// instance type, narrowed in TS 5.9). Most call sites — including protobuf-es generated
// code — produce the wider default `Uint8Array<ArrayBufferLike>`. Cast the inferred type
// to the wider variant so schemas line up with adjacent interface declarations.
export const uint8ArraySchema = z.instanceof(Uint8Array) as unknown as z.ZodType<Uint8Array>;
